package rendering

import ext.asVector2
import ext.size
import kotlinx.browser.window
import three.EffectComposer
import three.OutlinePass
import three.RenderPass
import three.ShaderPass
import three.js.Object3D
import three.js.ShaderMaterial
import three.js.Uniform

//
//class CustomOutlinePass(resolution: Vector2, scene: Scene, camera: Camera) : OutlinePass(resolution, scene, camera) {
//    override fun getOverlayMaterial(): ShaderMaterial {
//        return super.getOverlayMaterial()
//    }
//}

object EffectManager {
    private val composer = EffectComposer(RendererManager.renderer).also {
        it.addPass(RenderPass(SceneManager.scene, CameraManager.camera))
    }

    private fun createOutlinePass() = OutlinePass(window.size.asVector2(), SceneManager.scene, CameraManager.camera).also {
        it.edgeStrength = 5.0
        it.edgeGlow = 0.0
        it.edgeThickness = 1.0
        it.pulsePeriod = 0.0
        it.visibleEdgeColor.set(0xffffff)
//        it.hiddenEdgeColor.set(0x999999)
//        it.hiddenEdgeColor.set(0x0)
        it.hiddenEdgeColor.set(0x0)
    }.also(composer::addPass)

    private val invertShader = ShaderPass(ShaderMaterial().apply {
        uniforms["tDiffuse"] = Uniform(null)
        vertexShader = """
            varying vec2 vUv;
            void main() {
                vUv = uv;
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
        """.trimIndent()
        fragmentShader = """
            uniform sampler2D tDiffuse;
            varying vec2 vUv;
            void main() {
                vec4 color = texture2D(tDiffuse, vUv);
                gl_FragColor = vec4(vec3(1.0) - color.rgb, color.a); // Invert colors
            }
        """.trimIndent()
    })/*.also(composer::addPass)*/

    private var passes: Array<OutlinePass> = Array(1) { createOutlinePass() }

//    private val outlinePass = createOutlinePass()

    fun init() {
        window.addEventListener("resize", {
            // todo somehow fix resolution when resizing
//            outlinePass.resolution = window.size.asVector2()
        })
    }

    fun select(objects: Array<Object3D>) {
        println("selecting ${objects.size} objects")

        if (objects.size > passes.size) {
            passes = Array(objects.size) { createOutlinePass() }
        }

        objects.forEachIndexed { index, object3D ->
            passes[index].selectedObjects = arrayOf(object3D)
        }
        // clear the rest
        for (i in objects.size until passes.size) {
            passes[i].selectedObjects = emptyArray()
        }
    }

    fun render() = composer.render()
}